export default __webpack_public_path__ + "static/sdk-emoji-6b479eb2735ff165f51d2c9b98e4fc0f.gif";